/* tslint:disable */
/* eslint-disable */
/**
 * Trust Investigation API
 * The Law Society Trust Investigation Api with Swagger, Swashbuckle, and API Versioning.
 *
 * OpenAPI spec version: 2.0
 * Contact: hitesh.patel@lawsociety.com.au
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { BooleanResponse } from '../models';
import { ComplianceFormFileRequest } from '../models';
import { ComplianceFormFileResponse } from '../models';
import { FileRequest } from '../models';
import { FileViewResponse } from '../models';
import { Int32Response } from '../models';
import { RegeneratedFileLogIEnumerableResponse } from '../models';
/**
 * FileAtcsApi - axios parameter creator
 * @export
 */
export const FileAtcsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary TaAll | Delete AdditionalFile
         * @param {number} complianceFormId 
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsAdminDeleteAdditionalFileComplianceFormIdFileIdDelete: async (complianceFormId: number, fileId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'complianceFormId' is not null or undefined
            if (complianceFormId === null || complianceFormId === undefined) {
                throw new RequiredError('complianceFormId','Required parameter complianceFormId was null or undefined when calling apiV2FileAtcsAdminDeleteAdditionalFileComplianceFormIdFileIdDelete.');
            }
            // verify required parameter 'fileId' is not null or undefined
            if (fileId === null || fileId === undefined) {
                throw new RequiredError('fileId','Required parameter fileId was null or undefined when calling apiV2FileAtcsAdminDeleteAdditionalFileComplianceFormIdFileIdDelete.');
            }
            const localVarPath = `/api/v2/FileAtcs/Admin/DeleteAdditionalFile/{complianceFormId}/{fileId}`
                .replace(`{${"complianceFormId"}}`, encodeURIComponent(String(complianceFormId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TaAll | Delete File
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsAdminDeleteFileFileIdDelete: async (fileId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            if (fileId === null || fileId === undefined) {
                throw new RequiredError('fileId','Required parameter fileId was null or undefined when calling apiV2FileAtcsAdminDeleteFileFileIdDelete.');
            }
            const localVarPath = `/api/v2/FileAtcs/Admin/DeleteFile/{fileId}`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TaAll | Returns file as stream
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsAdminDownloadStreamFileIdGet: async (fileId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            if (fileId === null || fileId === undefined) {
                throw new RequiredError('fileId','Required parameter fileId was null or undefined when calling apiV2FileAtcsAdminDownloadStreamFileIdGet.');
            }
            const localVarPath = `/api/v2/FileAtcs/Admin/Download-stream/{fileId}`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns file
         * @param {number} eeReportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsAdminGetEeReportFileEeReportIdGet: async (eeReportId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eeReportId' is not null or undefined
            if (eeReportId === null || eeReportId === undefined) {
                throw new RequiredError('eeReportId','Required parameter eeReportId was null or undefined when calling apiV2FileAtcsAdminGetEeReportFileEeReportIdGet.');
            }
            const localVarPath = `/api/v2/FileAtcs/Admin/GetEeReportFile/{eeReportId}`
                .replace(`{${"eeReportId"}}`, encodeURIComponent(String(eeReportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns file
         * @param {number} eeReportId 
         * @param {number} regeneratedFileLogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsAdminGetEeReportFileEeReportIdRegeneratedFileLogIdGet: async (eeReportId: number, regeneratedFileLogId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eeReportId' is not null or undefined
            if (eeReportId === null || eeReportId === undefined) {
                throw new RequiredError('eeReportId','Required parameter eeReportId was null or undefined when calling apiV2FileAtcsAdminGetEeReportFileEeReportIdRegeneratedFileLogIdGet.');
            }
            // verify required parameter 'regeneratedFileLogId' is not null or undefined
            if (regeneratedFileLogId === null || regeneratedFileLogId === undefined) {
                throw new RequiredError('regeneratedFileLogId','Required parameter regeneratedFileLogId was null or undefined when calling apiV2FileAtcsAdminGetEeReportFileEeReportIdRegeneratedFileLogIdGet.');
            }
            const localVarPath = `/api/v2/FileAtcs/Admin/GetEeReportFile/{eeReportId}/{regeneratedFileLogId}`
                .replace(`{${"eeReportId"}}`, encodeURIComponent(String(eeReportId)))
                .replace(`{${"regeneratedFileLogId"}}`, encodeURIComponent(String(regeneratedFileLogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns EeReport Logs
         * @param {number} eeReportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsAdminGetEeReportFileLogsEeReportIdGet: async (eeReportId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eeReportId' is not null or undefined
            if (eeReportId === null || eeReportId === undefined) {
                throw new RequiredError('eeReportId','Required parameter eeReportId was null or undefined when calling apiV2FileAtcsAdminGetEeReportFileLogsEeReportIdGet.');
            }
            const localVarPath = `/api/v2/FileAtcs/Admin/GetEeReportFileLogs/{eeReportId}`
                .replace(`{${"eeReportId"}}`, encodeURIComponent(String(eeReportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TaAll | Returns file
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsAdminGetFileByIdFileIdGet: async (fileId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            if (fileId === null || fileId === undefined) {
                throw new RequiredError('fileId','Required parameter fileId was null or undefined when calling apiV2FileAtcsAdminGetFileByIdFileIdGet.');
            }
            const localVarPath = `/api/v2/FileAtcs/Admin/GetFileById/{fileId}`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns PartA Logs
         * @param {number} partAId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsAdminGetPartAFileLogsPartAIdGet: async (partAId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partAId' is not null or undefined
            if (partAId === null || partAId === undefined) {
                throw new RequiredError('partAId','Required parameter partAId was null or undefined when calling apiV2FileAtcsAdminGetPartAFileLogsPartAIdGet.');
            }
            const localVarPath = `/api/v2/FileAtcs/Admin/GetPartAFileLogs/{partAId}`
                .replace(`{${"partAId"}}`, encodeURIComponent(String(partAId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns file
         * @param {number} partAId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsAdminGetPartAFilePartAIdGet: async (partAId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partAId' is not null or undefined
            if (partAId === null || partAId === undefined) {
                throw new RequiredError('partAId','Required parameter partAId was null or undefined when calling apiV2FileAtcsAdminGetPartAFilePartAIdGet.');
            }
            const localVarPath = `/api/v2/FileAtcs/Admin/GetPartAFile/{partAId}`
                .replace(`{${"partAId"}}`, encodeURIComponent(String(partAId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns file
         * @param {number} partAId 
         * @param {number} regeneratedFileLogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsAdminGetPartAFilePartAIdRegeneratedFileLogIdGet: async (partAId: number, regeneratedFileLogId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partAId' is not null or undefined
            if (partAId === null || partAId === undefined) {
                throw new RequiredError('partAId','Required parameter partAId was null or undefined when calling apiV2FileAtcsAdminGetPartAFilePartAIdRegeneratedFileLogIdGet.');
            }
            // verify required parameter 'regeneratedFileLogId' is not null or undefined
            if (regeneratedFileLogId === null || regeneratedFileLogId === undefined) {
                throw new RequiredError('regeneratedFileLogId','Required parameter regeneratedFileLogId was null or undefined when calling apiV2FileAtcsAdminGetPartAFilePartAIdRegeneratedFileLogIdGet.');
            }
            const localVarPath = `/api/v2/FileAtcs/Admin/GetPartAFile/{partAId}/{regeneratedFileLogId}`
                .replace(`{${"partAId"}}`, encodeURIComponent(String(partAId)))
                .replace(`{${"regeneratedFileLogId"}}`, encodeURIComponent(String(regeneratedFileLogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns PartB Logs
         * @param {number} partBId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsAdminGetPartBFileLogsPartBIdGet: async (partBId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partBId' is not null or undefined
            if (partBId === null || partBId === undefined) {
                throw new RequiredError('partBId','Required parameter partBId was null or undefined when calling apiV2FileAtcsAdminGetPartBFileLogsPartBIdGet.');
            }
            const localVarPath = `/api/v2/FileAtcs/Admin/GetPartBFileLogs/{partBId}`
                .replace(`{${"partBId"}}`, encodeURIComponent(String(partBId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns file
         * @param {number} partBId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsAdminGetPartBFilePartBIdGet: async (partBId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partBId' is not null or undefined
            if (partBId === null || partBId === undefined) {
                throw new RequiredError('partBId','Required parameter partBId was null or undefined when calling apiV2FileAtcsAdminGetPartBFilePartBIdGet.');
            }
            const localVarPath = `/api/v2/FileAtcs/Admin/GetPartBFile/{partBId}`
                .replace(`{${"partBId"}}`, encodeURIComponent(String(partBId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns file
         * @param {number} partBId 
         * @param {number} regeneratedFileLogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsAdminGetPartBFilePartBIdRegeneratedFileLogIdGet: async (partBId: number, regeneratedFileLogId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partBId' is not null or undefined
            if (partBId === null || partBId === undefined) {
                throw new RequiredError('partBId','Required parameter partBId was null or undefined when calling apiV2FileAtcsAdminGetPartBFilePartBIdRegeneratedFileLogIdGet.');
            }
            // verify required parameter 'regeneratedFileLogId' is not null or undefined
            if (regeneratedFileLogId === null || regeneratedFileLogId === undefined) {
                throw new RequiredError('regeneratedFileLogId','Required parameter regeneratedFileLogId was null or undefined when calling apiV2FileAtcsAdminGetPartBFilePartBIdRegeneratedFileLogIdGet.');
            }
            const localVarPath = `/api/v2/FileAtcs/Admin/GetPartBFile/{partBId}/{regeneratedFileLogId}`
                .replace(`{${"partBId"}}`, encodeURIComponent(String(partBId)))
                .replace(`{${"regeneratedFileLogId"}}`, encodeURIComponent(String(regeneratedFileLogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ta All | Returns true when File is saved
         * @param {ComplianceFormFileRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsAdminSaveComplianceFormAdditionalFilePost: async (body?: ComplianceFormFileRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/FileAtcs/Admin/SaveComplianceFormAdditionalFile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TaAll | Returns FileId
         * @param {FileRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsAdminSaveExternalExaminerFilePost: async (body?: FileRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/FileAtcs/Admin/SaveExternalExaminerFile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary AllAtcs | Delete File
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsDeleteFileFileIdDelete: async (fileId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            if (fileId === null || fileId === undefined) {
                throw new RequiredError('fileId','Required parameter fileId was null or undefined when calling apiV2FileAtcsDeleteFileFileIdDelete.');
            }
            const localVarPath = `/api/v2/FileAtcs/DeleteFile/{fileId}`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary AllAtcs | Returns file as stream
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsDownloadStreamFileIdGet: async (fileId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            if (fileId === null || fileId === undefined) {
                throw new RequiredError('fileId','Required parameter fileId was null or undefined when calling apiV2FileAtcsDownloadStreamFileIdGet.');
            }
            const localVarPath = `/api/v2/FileAtcs/Download-stream/{fileId}`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary AllAtcs | Returns file
         * @param {number} fileId 
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsGetComplianceFormFileByIdFileIdComplianceFormIdGet: async (fileId: number, complianceFormId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            if (fileId === null || fileId === undefined) {
                throw new RequiredError('fileId','Required parameter fileId was null or undefined when calling apiV2FileAtcsGetComplianceFormFileByIdFileIdComplianceFormIdGet.');
            }
            // verify required parameter 'complianceFormId' is not null or undefined
            if (complianceFormId === null || complianceFormId === undefined) {
                throw new RequiredError('complianceFormId','Required parameter complianceFormId was null or undefined when calling apiV2FileAtcsGetComplianceFormFileByIdFileIdComplianceFormIdGet.');
            }
            const localVarPath = `/api/v2/FileAtcs/GetComplianceFormFileById/{fileId}/{complianceFormId}`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)))
                .replace(`{${"complianceFormId"}}`, encodeURIComponent(String(complianceFormId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ExternalExaminer | Returns file
         * @param {number} eeReportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsGetEeReportFileEeReportIdGet: async (eeReportId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eeReportId' is not null or undefined
            if (eeReportId === null || eeReportId === undefined) {
                throw new RequiredError('eeReportId','Required parameter eeReportId was null or undefined when calling apiV2FileAtcsGetEeReportFileEeReportIdGet.');
            }
            const localVarPath = `/api/v2/FileAtcs/GetEeReportFile/{eeReportId}`
                .replace(`{${"eeReportId"}}`, encodeURIComponent(String(eeReportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary AllAtcs | Returns file
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsGetFileByIdFileIdGet: async (fileId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            if (fileId === null || fileId === undefined) {
                throw new RequiredError('fileId','Required parameter fileId was null or undefined when calling apiV2FileAtcsGetFileByIdFileIdGet.');
            }
            const localVarPath = `/api/v2/FileAtcs/GetFileById/{fileId}`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal / TrustContact / ExternalExaminer | Returns file
         * @param {number} partAId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsGetPartAFilePartAIdGet: async (partAId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partAId' is not null or undefined
            if (partAId === null || partAId === undefined) {
                throw new RequiredError('partAId','Required parameter partAId was null or undefined when calling apiV2FileAtcsGetPartAFilePartAIdGet.');
            }
            const localVarPath = `/api/v2/FileAtcs/GetPartAFile/{partAId}`
                .replace(`{${"partAId"}}`, encodeURIComponent(String(partAId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal / TrustContact / ExternalExaminer | Returns file
         * @param {number} partBId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsGetPartBFilePartBIdGet: async (partBId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partBId' is not null or undefined
            if (partBId === null || partBId === undefined) {
                throw new RequiredError('partBId','Required parameter partBId was null or undefined when calling apiV2FileAtcsGetPartBFilePartBIdGet.');
            }
            const localVarPath = `/api/v2/FileAtcs/GetPartBFile/{partBId}`
                .replace(`{${"partBId"}}`, encodeURIComponent(String(partBId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal, TrustCoordinator, TrustContact | Returns FileId
         * @param {ComplianceFormFileRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsSaveComplianceFormFilePost: async (body?: ComplianceFormFileRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/FileAtcs/SaveComplianceFormFile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary AllAtcs | Returns FileId
         * @param {FileRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsSaveEeSignUpFormFilePost: async (body?: FileRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/FileAtcs/SaveEeSignUpFormFile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary AllAtcs | Returns FileId
         * @param {FileRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsSaveFilePost: async (body?: FileRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/FileAtcs/SaveFile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TrustInvestigator | Returns file
         * @param {number} complianceFormId 
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsTrustInvestigatorGetComplianceFormAdditionalFileComplianceFormIdFileIdGet: async (complianceFormId: number, fileId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'complianceFormId' is not null or undefined
            if (complianceFormId === null || complianceFormId === undefined) {
                throw new RequiredError('complianceFormId','Required parameter complianceFormId was null or undefined when calling apiV2FileAtcsTrustInvestigatorGetComplianceFormAdditionalFileComplianceFormIdFileIdGet.');
            }
            // verify required parameter 'fileId' is not null or undefined
            if (fileId === null || fileId === undefined) {
                throw new RequiredError('fileId','Required parameter fileId was null or undefined when calling apiV2FileAtcsTrustInvestigatorGetComplianceFormAdditionalFileComplianceFormIdFileIdGet.');
            }
            const localVarPath = `/api/v2/FileAtcs/TrustInvestigator/GetComplianceFormAdditionalFile/{complianceFormId}/{fileId}`
                .replace(`{${"complianceFormId"}}`, encodeURIComponent(String(complianceFormId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TrustInvestigator | Returns EE Report - Overview
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsTrustInvestigatorGetComplianceFormFileAttachmentsComplianceFormIdGet: async (complianceFormId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'complianceFormId' is not null or undefined
            if (complianceFormId === null || complianceFormId === undefined) {
                throw new RequiredError('complianceFormId','Required parameter complianceFormId was null or undefined when calling apiV2FileAtcsTrustInvestigatorGetComplianceFormFileAttachmentsComplianceFormIdGet.');
            }
            const localVarPath = `/api/v2/FileAtcs/TrustInvestigator/GetComplianceFormFileAttachments/{complianceFormId}`
                .replace(`{${"complianceFormId"}}`, encodeURIComponent(String(complianceFormId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TrustInvestigator | Returns file
         * @param {number} fileId 
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsTrustInvestigatorGetComplianceFormFileByIdFileIdComplianceFormIdGet: async (fileId: number, complianceFormId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            if (fileId === null || fileId === undefined) {
                throw new RequiredError('fileId','Required parameter fileId was null or undefined when calling apiV2FileAtcsTrustInvestigatorGetComplianceFormFileByIdFileIdComplianceFormIdGet.');
            }
            // verify required parameter 'complianceFormId' is not null or undefined
            if (complianceFormId === null || complianceFormId === undefined) {
                throw new RequiredError('complianceFormId','Required parameter complianceFormId was null or undefined when calling apiV2FileAtcsTrustInvestigatorGetComplianceFormFileByIdFileIdComplianceFormIdGet.');
            }
            const localVarPath = `/api/v2/FileAtcs/TrustInvestigator/GetComplianceFormFileById/{fileId}/{complianceFormId}`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)))
                .replace(`{${"complianceFormId"}}`, encodeURIComponent(String(complianceFormId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TrustInvestigator | Returns file
         * @param {number} eeReportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsTrustInvestigatorGetEeReportFileEeReportIdGet: async (eeReportId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eeReportId' is not null or undefined
            if (eeReportId === null || eeReportId === undefined) {
                throw new RequiredError('eeReportId','Required parameter eeReportId was null or undefined when calling apiV2FileAtcsTrustInvestigatorGetEeReportFileEeReportIdGet.');
            }
            const localVarPath = `/api/v2/FileAtcs/TrustInvestigator/GetEeReportFile/{eeReportId}`
                .replace(`{${"eeReportId"}}`, encodeURIComponent(String(eeReportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TrustInvestigator | Returns file
         * @param {number} eeReportId 
         * @param {number} regeneratedFileLogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsTrustInvestigatorGetEeReportFileEeReportIdRegeneratedFileLogIdGet: async (eeReportId: number, regeneratedFileLogId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eeReportId' is not null or undefined
            if (eeReportId === null || eeReportId === undefined) {
                throw new RequiredError('eeReportId','Required parameter eeReportId was null or undefined when calling apiV2FileAtcsTrustInvestigatorGetEeReportFileEeReportIdRegeneratedFileLogIdGet.');
            }
            // verify required parameter 'regeneratedFileLogId' is not null or undefined
            if (regeneratedFileLogId === null || regeneratedFileLogId === undefined) {
                throw new RequiredError('regeneratedFileLogId','Required parameter regeneratedFileLogId was null or undefined when calling apiV2FileAtcsTrustInvestigatorGetEeReportFileEeReportIdRegeneratedFileLogIdGet.');
            }
            const localVarPath = `/api/v2/FileAtcs/TrustInvestigator/GetEeReportFile/{eeReportId}/{regeneratedFileLogId}`
                .replace(`{${"eeReportId"}}`, encodeURIComponent(String(eeReportId)))
                .replace(`{${"regeneratedFileLogId"}}`, encodeURIComponent(String(regeneratedFileLogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TrustInvestigator | Returns EeReport Logs
         * @param {number} eeReportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsTrustInvestigatorGetEeReportFileLogsEeReportIdGet: async (eeReportId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eeReportId' is not null or undefined
            if (eeReportId === null || eeReportId === undefined) {
                throw new RequiredError('eeReportId','Required parameter eeReportId was null or undefined when calling apiV2FileAtcsTrustInvestigatorGetEeReportFileLogsEeReportIdGet.');
            }
            const localVarPath = `/api/v2/FileAtcs/TrustInvestigator/GetEeReportFileLogs/{eeReportId}`
                .replace(`{${"eeReportId"}}`, encodeURIComponent(String(eeReportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TrustInvestigator | Returns PartA Logs
         * @param {number} partAId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsTrustInvestigatorGetPartAFileLogsPartAIdGet: async (partAId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partAId' is not null or undefined
            if (partAId === null || partAId === undefined) {
                throw new RequiredError('partAId','Required parameter partAId was null or undefined when calling apiV2FileAtcsTrustInvestigatorGetPartAFileLogsPartAIdGet.');
            }
            const localVarPath = `/api/v2/FileAtcs/TrustInvestigator/GetPartAFileLogs/{partAId}`
                .replace(`{${"partAId"}}`, encodeURIComponent(String(partAId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TrustInvestigator | Returns file
         * @param {number} partAId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsTrustInvestigatorGetPartAFilePartAIdGet: async (partAId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partAId' is not null or undefined
            if (partAId === null || partAId === undefined) {
                throw new RequiredError('partAId','Required parameter partAId was null or undefined when calling apiV2FileAtcsTrustInvestigatorGetPartAFilePartAIdGet.');
            }
            const localVarPath = `/api/v2/FileAtcs/TrustInvestigator/GetPartAFile/{partAId}`
                .replace(`{${"partAId"}}`, encodeURIComponent(String(partAId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TrustInvestigator | Returns file
         * @param {number} partAId 
         * @param {number} regeneratedFileLogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsTrustInvestigatorGetPartAFilePartAIdRegeneratedFileLogIdGet: async (partAId: number, regeneratedFileLogId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partAId' is not null or undefined
            if (partAId === null || partAId === undefined) {
                throw new RequiredError('partAId','Required parameter partAId was null or undefined when calling apiV2FileAtcsTrustInvestigatorGetPartAFilePartAIdRegeneratedFileLogIdGet.');
            }
            // verify required parameter 'regeneratedFileLogId' is not null or undefined
            if (regeneratedFileLogId === null || regeneratedFileLogId === undefined) {
                throw new RequiredError('regeneratedFileLogId','Required parameter regeneratedFileLogId was null or undefined when calling apiV2FileAtcsTrustInvestigatorGetPartAFilePartAIdRegeneratedFileLogIdGet.');
            }
            const localVarPath = `/api/v2/FileAtcs/TrustInvestigator/GetPartAFile/{partAId}/{regeneratedFileLogId}`
                .replace(`{${"partAId"}}`, encodeURIComponent(String(partAId)))
                .replace(`{${"regeneratedFileLogId"}}`, encodeURIComponent(String(regeneratedFileLogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TrustInvestigator | Returns PartB Logs
         * @param {number} partBId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsTrustInvestigatorGetPartBFileLogsPartBIdGet: async (partBId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partBId' is not null or undefined
            if (partBId === null || partBId === undefined) {
                throw new RequiredError('partBId','Required parameter partBId was null or undefined when calling apiV2FileAtcsTrustInvestigatorGetPartBFileLogsPartBIdGet.');
            }
            const localVarPath = `/api/v2/FileAtcs/TrustInvestigator/GetPartBFileLogs/{partBId}`
                .replace(`{${"partBId"}}`, encodeURIComponent(String(partBId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TrustInvestigator | Returns file
         * @param {number} partBId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsTrustInvestigatorGetPartBFilePartBIdGet: async (partBId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partBId' is not null or undefined
            if (partBId === null || partBId === undefined) {
                throw new RequiredError('partBId','Required parameter partBId was null or undefined when calling apiV2FileAtcsTrustInvestigatorGetPartBFilePartBIdGet.');
            }
            const localVarPath = `/api/v2/FileAtcs/TrustInvestigator/GetPartBFile/{partBId}`
                .replace(`{${"partBId"}}`, encodeURIComponent(String(partBId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TrustInvestigator | Returns file
         * @param {number} partBId 
         * @param {number} regeneratedFileLogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsTrustInvestigatorGetPartBFilePartBIdRegeneratedFileLogIdGet: async (partBId: number, regeneratedFileLogId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'partBId' is not null or undefined
            if (partBId === null || partBId === undefined) {
                throw new RequiredError('partBId','Required parameter partBId was null or undefined when calling apiV2FileAtcsTrustInvestigatorGetPartBFilePartBIdRegeneratedFileLogIdGet.');
            }
            // verify required parameter 'regeneratedFileLogId' is not null or undefined
            if (regeneratedFileLogId === null || regeneratedFileLogId === undefined) {
                throw new RequiredError('regeneratedFileLogId','Required parameter regeneratedFileLogId was null or undefined when calling apiV2FileAtcsTrustInvestigatorGetPartBFilePartBIdRegeneratedFileLogIdGet.');
            }
            const localVarPath = `/api/v2/FileAtcs/TrustInvestigator/GetPartBFile/{partBId}/{regeneratedFileLogId}`
                .replace(`{${"partBId"}}`, encodeURIComponent(String(partBId)))
                .replace(`{${"regeneratedFileLogId"}}`, encodeURIComponent(String(regeneratedFileLogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FileAtcsApi - functional programming interface
 * @export
 */
export const FileAtcsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary TaAll | Delete AdditionalFile
         * @param {number} complianceFormId 
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2FileAtcsAdminDeleteAdditionalFileComplianceFormIdFileIdDelete(complianceFormId: number, fileId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await FileAtcsApiAxiosParamCreator(configuration).apiV2FileAtcsAdminDeleteAdditionalFileComplianceFormIdFileIdDelete(complianceFormId, fileId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TaAll | Delete File
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2FileAtcsAdminDeleteFileFileIdDelete(fileId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await FileAtcsApiAxiosParamCreator(configuration).apiV2FileAtcsAdminDeleteFileFileIdDelete(fileId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TaAll | Returns file as stream
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2FileAtcsAdminDownloadStreamFileIdGet(fileId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await FileAtcsApiAxiosParamCreator(configuration).apiV2FileAtcsAdminDownloadStreamFileIdGet(fileId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns file
         * @param {number} eeReportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2FileAtcsAdminGetEeReportFileEeReportIdGet(eeReportId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileViewResponse>> {
            const localVarAxiosArgs = await FileAtcsApiAxiosParamCreator(configuration).apiV2FileAtcsAdminGetEeReportFileEeReportIdGet(eeReportId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns file
         * @param {number} eeReportId 
         * @param {number} regeneratedFileLogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2FileAtcsAdminGetEeReportFileEeReportIdRegeneratedFileLogIdGet(eeReportId: number, regeneratedFileLogId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileViewResponse>> {
            const localVarAxiosArgs = await FileAtcsApiAxiosParamCreator(configuration).apiV2FileAtcsAdminGetEeReportFileEeReportIdRegeneratedFileLogIdGet(eeReportId, regeneratedFileLogId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns EeReport Logs
         * @param {number} eeReportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2FileAtcsAdminGetEeReportFileLogsEeReportIdGet(eeReportId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegeneratedFileLogIEnumerableResponse>> {
            const localVarAxiosArgs = await FileAtcsApiAxiosParamCreator(configuration).apiV2FileAtcsAdminGetEeReportFileLogsEeReportIdGet(eeReportId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TaAll | Returns file
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2FileAtcsAdminGetFileByIdFileIdGet(fileId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileViewResponse>> {
            const localVarAxiosArgs = await FileAtcsApiAxiosParamCreator(configuration).apiV2FileAtcsAdminGetFileByIdFileIdGet(fileId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns PartA Logs
         * @param {number} partAId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2FileAtcsAdminGetPartAFileLogsPartAIdGet(partAId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegeneratedFileLogIEnumerableResponse>> {
            const localVarAxiosArgs = await FileAtcsApiAxiosParamCreator(configuration).apiV2FileAtcsAdminGetPartAFileLogsPartAIdGet(partAId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns file
         * @param {number} partAId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2FileAtcsAdminGetPartAFilePartAIdGet(partAId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileViewResponse>> {
            const localVarAxiosArgs = await FileAtcsApiAxiosParamCreator(configuration).apiV2FileAtcsAdminGetPartAFilePartAIdGet(partAId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns file
         * @param {number} partAId 
         * @param {number} regeneratedFileLogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2FileAtcsAdminGetPartAFilePartAIdRegeneratedFileLogIdGet(partAId: number, regeneratedFileLogId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileViewResponse>> {
            const localVarAxiosArgs = await FileAtcsApiAxiosParamCreator(configuration).apiV2FileAtcsAdminGetPartAFilePartAIdRegeneratedFileLogIdGet(partAId, regeneratedFileLogId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns PartB Logs
         * @param {number} partBId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2FileAtcsAdminGetPartBFileLogsPartBIdGet(partBId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegeneratedFileLogIEnumerableResponse>> {
            const localVarAxiosArgs = await FileAtcsApiAxiosParamCreator(configuration).apiV2FileAtcsAdminGetPartBFileLogsPartBIdGet(partBId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns file
         * @param {number} partBId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2FileAtcsAdminGetPartBFilePartBIdGet(partBId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileViewResponse>> {
            const localVarAxiosArgs = await FileAtcsApiAxiosParamCreator(configuration).apiV2FileAtcsAdminGetPartBFilePartBIdGet(partBId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns file
         * @param {number} partBId 
         * @param {number} regeneratedFileLogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2FileAtcsAdminGetPartBFilePartBIdRegeneratedFileLogIdGet(partBId: number, regeneratedFileLogId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileViewResponse>> {
            const localVarAxiosArgs = await FileAtcsApiAxiosParamCreator(configuration).apiV2FileAtcsAdminGetPartBFilePartBIdRegeneratedFileLogIdGet(partBId, regeneratedFileLogId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Ta All | Returns true when File is saved
         * @param {ComplianceFormFileRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2FileAtcsAdminSaveComplianceFormAdditionalFilePost(body?: ComplianceFormFileRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await FileAtcsApiAxiosParamCreator(configuration).apiV2FileAtcsAdminSaveComplianceFormAdditionalFilePost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TaAll | Returns FileId
         * @param {FileRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2FileAtcsAdminSaveExternalExaminerFilePost(body?: FileRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32Response>> {
            const localVarAxiosArgs = await FileAtcsApiAxiosParamCreator(configuration).apiV2FileAtcsAdminSaveExternalExaminerFilePost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary AllAtcs | Delete File
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2FileAtcsDeleteFileFileIdDelete(fileId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await FileAtcsApiAxiosParamCreator(configuration).apiV2FileAtcsDeleteFileFileIdDelete(fileId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary AllAtcs | Returns file as stream
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2FileAtcsDownloadStreamFileIdGet(fileId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await FileAtcsApiAxiosParamCreator(configuration).apiV2FileAtcsDownloadStreamFileIdGet(fileId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary AllAtcs | Returns file
         * @param {number} fileId 
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2FileAtcsGetComplianceFormFileByIdFileIdComplianceFormIdGet(fileId: number, complianceFormId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileViewResponse>> {
            const localVarAxiosArgs = await FileAtcsApiAxiosParamCreator(configuration).apiV2FileAtcsGetComplianceFormFileByIdFileIdComplianceFormIdGet(fileId, complianceFormId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary ExternalExaminer | Returns file
         * @param {number} eeReportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2FileAtcsGetEeReportFileEeReportIdGet(eeReportId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileViewResponse>> {
            const localVarAxiosArgs = await FileAtcsApiAxiosParamCreator(configuration).apiV2FileAtcsGetEeReportFileEeReportIdGet(eeReportId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary AllAtcs | Returns file
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2FileAtcsGetFileByIdFileIdGet(fileId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileViewResponse>> {
            const localVarAxiosArgs = await FileAtcsApiAxiosParamCreator(configuration).apiV2FileAtcsGetFileByIdFileIdGet(fileId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal / TrustContact / ExternalExaminer | Returns file
         * @param {number} partAId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2FileAtcsGetPartAFilePartAIdGet(partAId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileViewResponse>> {
            const localVarAxiosArgs = await FileAtcsApiAxiosParamCreator(configuration).apiV2FileAtcsGetPartAFilePartAIdGet(partAId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal / TrustContact / ExternalExaminer | Returns file
         * @param {number} partBId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2FileAtcsGetPartBFilePartBIdGet(partBId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileViewResponse>> {
            const localVarAxiosArgs = await FileAtcsApiAxiosParamCreator(configuration).apiV2FileAtcsGetPartBFilePartBIdGet(partBId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal, TrustCoordinator, TrustContact | Returns FileId
         * @param {ComplianceFormFileRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2FileAtcsSaveComplianceFormFilePost(body?: ComplianceFormFileRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32Response>> {
            const localVarAxiosArgs = await FileAtcsApiAxiosParamCreator(configuration).apiV2FileAtcsSaveComplianceFormFilePost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary AllAtcs | Returns FileId
         * @param {FileRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2FileAtcsSaveEeSignUpFormFilePost(body?: FileRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32Response>> {
            const localVarAxiosArgs = await FileAtcsApiAxiosParamCreator(configuration).apiV2FileAtcsSaveEeSignUpFormFilePost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary AllAtcs | Returns FileId
         * @param {FileRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2FileAtcsSaveFilePost(body?: FileRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32Response>> {
            const localVarAxiosArgs = await FileAtcsApiAxiosParamCreator(configuration).apiV2FileAtcsSaveFilePost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TrustInvestigator | Returns file
         * @param {number} complianceFormId 
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2FileAtcsTrustInvestigatorGetComplianceFormAdditionalFileComplianceFormIdFileIdGet(complianceFormId: number, fileId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileViewResponse>> {
            const localVarAxiosArgs = await FileAtcsApiAxiosParamCreator(configuration).apiV2FileAtcsTrustInvestigatorGetComplianceFormAdditionalFileComplianceFormIdFileIdGet(complianceFormId, fileId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TrustInvestigator | Returns EE Report - Overview
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2FileAtcsTrustInvestigatorGetComplianceFormFileAttachmentsComplianceFormIdGet(complianceFormId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComplianceFormFileResponse>> {
            const localVarAxiosArgs = await FileAtcsApiAxiosParamCreator(configuration).apiV2FileAtcsTrustInvestigatorGetComplianceFormFileAttachmentsComplianceFormIdGet(complianceFormId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TrustInvestigator | Returns file
         * @param {number} fileId 
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2FileAtcsTrustInvestigatorGetComplianceFormFileByIdFileIdComplianceFormIdGet(fileId: number, complianceFormId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileViewResponse>> {
            const localVarAxiosArgs = await FileAtcsApiAxiosParamCreator(configuration).apiV2FileAtcsTrustInvestigatorGetComplianceFormFileByIdFileIdComplianceFormIdGet(fileId, complianceFormId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TrustInvestigator | Returns file
         * @param {number} eeReportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2FileAtcsTrustInvestigatorGetEeReportFileEeReportIdGet(eeReportId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileViewResponse>> {
            const localVarAxiosArgs = await FileAtcsApiAxiosParamCreator(configuration).apiV2FileAtcsTrustInvestigatorGetEeReportFileEeReportIdGet(eeReportId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TrustInvestigator | Returns file
         * @param {number} eeReportId 
         * @param {number} regeneratedFileLogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2FileAtcsTrustInvestigatorGetEeReportFileEeReportIdRegeneratedFileLogIdGet(eeReportId: number, regeneratedFileLogId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileViewResponse>> {
            const localVarAxiosArgs = await FileAtcsApiAxiosParamCreator(configuration).apiV2FileAtcsTrustInvestigatorGetEeReportFileEeReportIdRegeneratedFileLogIdGet(eeReportId, regeneratedFileLogId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TrustInvestigator | Returns EeReport Logs
         * @param {number} eeReportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2FileAtcsTrustInvestigatorGetEeReportFileLogsEeReportIdGet(eeReportId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegeneratedFileLogIEnumerableResponse>> {
            const localVarAxiosArgs = await FileAtcsApiAxiosParamCreator(configuration).apiV2FileAtcsTrustInvestigatorGetEeReportFileLogsEeReportIdGet(eeReportId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TrustInvestigator | Returns PartA Logs
         * @param {number} partAId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2FileAtcsTrustInvestigatorGetPartAFileLogsPartAIdGet(partAId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegeneratedFileLogIEnumerableResponse>> {
            const localVarAxiosArgs = await FileAtcsApiAxiosParamCreator(configuration).apiV2FileAtcsTrustInvestigatorGetPartAFileLogsPartAIdGet(partAId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TrustInvestigator | Returns file
         * @param {number} partAId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2FileAtcsTrustInvestigatorGetPartAFilePartAIdGet(partAId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileViewResponse>> {
            const localVarAxiosArgs = await FileAtcsApiAxiosParamCreator(configuration).apiV2FileAtcsTrustInvestigatorGetPartAFilePartAIdGet(partAId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TrustInvestigator | Returns file
         * @param {number} partAId 
         * @param {number} regeneratedFileLogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2FileAtcsTrustInvestigatorGetPartAFilePartAIdRegeneratedFileLogIdGet(partAId: number, regeneratedFileLogId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileViewResponse>> {
            const localVarAxiosArgs = await FileAtcsApiAxiosParamCreator(configuration).apiV2FileAtcsTrustInvestigatorGetPartAFilePartAIdRegeneratedFileLogIdGet(partAId, regeneratedFileLogId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TrustInvestigator | Returns PartB Logs
         * @param {number} partBId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2FileAtcsTrustInvestigatorGetPartBFileLogsPartBIdGet(partBId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegeneratedFileLogIEnumerableResponse>> {
            const localVarAxiosArgs = await FileAtcsApiAxiosParamCreator(configuration).apiV2FileAtcsTrustInvestigatorGetPartBFileLogsPartBIdGet(partBId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TrustInvestigator | Returns file
         * @param {number} partBId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2FileAtcsTrustInvestigatorGetPartBFilePartBIdGet(partBId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileViewResponse>> {
            const localVarAxiosArgs = await FileAtcsApiAxiosParamCreator(configuration).apiV2FileAtcsTrustInvestigatorGetPartBFilePartBIdGet(partBId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TrustInvestigator | Returns file
         * @param {number} partBId 
         * @param {number} regeneratedFileLogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2FileAtcsTrustInvestigatorGetPartBFilePartBIdRegeneratedFileLogIdGet(partBId: number, regeneratedFileLogId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileViewResponse>> {
            const localVarAxiosArgs = await FileAtcsApiAxiosParamCreator(configuration).apiV2FileAtcsTrustInvestigatorGetPartBFilePartBIdRegeneratedFileLogIdGet(partBId, regeneratedFileLogId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * FileAtcsApi - factory interface
 * @export
 */
export const FileAtcsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary TaAll | Delete AdditionalFile
         * @param {number} complianceFormId 
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsAdminDeleteAdditionalFileComplianceFormIdFileIdDelete(complianceFormId: number, fileId: number, options?: any): AxiosPromise<BooleanResponse> {
            return FileAtcsApiFp(configuration).apiV2FileAtcsAdminDeleteAdditionalFileComplianceFormIdFileIdDelete(complianceFormId, fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TaAll | Delete File
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsAdminDeleteFileFileIdDelete(fileId: number, options?: any): AxiosPromise<BooleanResponse> {
            return FileAtcsApiFp(configuration).apiV2FileAtcsAdminDeleteFileFileIdDelete(fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TaAll | Returns file as stream
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsAdminDownloadStreamFileIdGet(fileId: number, options?: any): AxiosPromise<string> {
            return FileAtcsApiFp(configuration).apiV2FileAtcsAdminDownloadStreamFileIdGet(fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns file
         * @param {number} eeReportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsAdminGetEeReportFileEeReportIdGet(eeReportId: number, options?: any): AxiosPromise<FileViewResponse> {
            return FileAtcsApiFp(configuration).apiV2FileAtcsAdminGetEeReportFileEeReportIdGet(eeReportId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns file
         * @param {number} eeReportId 
         * @param {number} regeneratedFileLogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsAdminGetEeReportFileEeReportIdRegeneratedFileLogIdGet(eeReportId: number, regeneratedFileLogId: number, options?: any): AxiosPromise<FileViewResponse> {
            return FileAtcsApiFp(configuration).apiV2FileAtcsAdminGetEeReportFileEeReportIdRegeneratedFileLogIdGet(eeReportId, regeneratedFileLogId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns EeReport Logs
         * @param {number} eeReportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsAdminGetEeReportFileLogsEeReportIdGet(eeReportId: number, options?: any): AxiosPromise<RegeneratedFileLogIEnumerableResponse> {
            return FileAtcsApiFp(configuration).apiV2FileAtcsAdminGetEeReportFileLogsEeReportIdGet(eeReportId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TaAll | Returns file
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsAdminGetFileByIdFileIdGet(fileId: number, options?: any): AxiosPromise<FileViewResponse> {
            return FileAtcsApiFp(configuration).apiV2FileAtcsAdminGetFileByIdFileIdGet(fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns PartA Logs
         * @param {number} partAId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsAdminGetPartAFileLogsPartAIdGet(partAId: number, options?: any): AxiosPromise<RegeneratedFileLogIEnumerableResponse> {
            return FileAtcsApiFp(configuration).apiV2FileAtcsAdminGetPartAFileLogsPartAIdGet(partAId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns file
         * @param {number} partAId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsAdminGetPartAFilePartAIdGet(partAId: number, options?: any): AxiosPromise<FileViewResponse> {
            return FileAtcsApiFp(configuration).apiV2FileAtcsAdminGetPartAFilePartAIdGet(partAId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns file
         * @param {number} partAId 
         * @param {number} regeneratedFileLogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsAdminGetPartAFilePartAIdRegeneratedFileLogIdGet(partAId: number, regeneratedFileLogId: number, options?: any): AxiosPromise<FileViewResponse> {
            return FileAtcsApiFp(configuration).apiV2FileAtcsAdminGetPartAFilePartAIdRegeneratedFileLogIdGet(partAId, regeneratedFileLogId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns PartB Logs
         * @param {number} partBId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsAdminGetPartBFileLogsPartBIdGet(partBId: number, options?: any): AxiosPromise<RegeneratedFileLogIEnumerableResponse> {
            return FileAtcsApiFp(configuration).apiV2FileAtcsAdminGetPartBFileLogsPartBIdGet(partBId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns file
         * @param {number} partBId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsAdminGetPartBFilePartBIdGet(partBId: number, options?: any): AxiosPromise<FileViewResponse> {
            return FileAtcsApiFp(configuration).apiV2FileAtcsAdminGetPartBFilePartBIdGet(partBId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns file
         * @param {number} partBId 
         * @param {number} regeneratedFileLogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsAdminGetPartBFilePartBIdRegeneratedFileLogIdGet(partBId: number, regeneratedFileLogId: number, options?: any): AxiosPromise<FileViewResponse> {
            return FileAtcsApiFp(configuration).apiV2FileAtcsAdminGetPartBFilePartBIdRegeneratedFileLogIdGet(partBId, regeneratedFileLogId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ta All | Returns true when File is saved
         * @param {ComplianceFormFileRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsAdminSaveComplianceFormAdditionalFilePost(body?: ComplianceFormFileRequest, options?: any): AxiosPromise<BooleanResponse> {
            return FileAtcsApiFp(configuration).apiV2FileAtcsAdminSaveComplianceFormAdditionalFilePost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TaAll | Returns FileId
         * @param {FileRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsAdminSaveExternalExaminerFilePost(body?: FileRequest, options?: any): AxiosPromise<Int32Response> {
            return FileAtcsApiFp(configuration).apiV2FileAtcsAdminSaveExternalExaminerFilePost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary AllAtcs | Delete File
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsDeleteFileFileIdDelete(fileId: number, options?: any): AxiosPromise<BooleanResponse> {
            return FileAtcsApiFp(configuration).apiV2FileAtcsDeleteFileFileIdDelete(fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary AllAtcs | Returns file as stream
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsDownloadStreamFileIdGet(fileId: number, options?: any): AxiosPromise<string> {
            return FileAtcsApiFp(configuration).apiV2FileAtcsDownloadStreamFileIdGet(fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary AllAtcs | Returns file
         * @param {number} fileId 
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsGetComplianceFormFileByIdFileIdComplianceFormIdGet(fileId: number, complianceFormId: number, options?: any): AxiosPromise<FileViewResponse> {
            return FileAtcsApiFp(configuration).apiV2FileAtcsGetComplianceFormFileByIdFileIdComplianceFormIdGet(fileId, complianceFormId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ExternalExaminer | Returns file
         * @param {number} eeReportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsGetEeReportFileEeReportIdGet(eeReportId: number, options?: any): AxiosPromise<FileViewResponse> {
            return FileAtcsApiFp(configuration).apiV2FileAtcsGetEeReportFileEeReportIdGet(eeReportId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary AllAtcs | Returns file
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsGetFileByIdFileIdGet(fileId: number, options?: any): AxiosPromise<FileViewResponse> {
            return FileAtcsApiFp(configuration).apiV2FileAtcsGetFileByIdFileIdGet(fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal / TrustContact / ExternalExaminer | Returns file
         * @param {number} partAId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsGetPartAFilePartAIdGet(partAId: number, options?: any): AxiosPromise<FileViewResponse> {
            return FileAtcsApiFp(configuration).apiV2FileAtcsGetPartAFilePartAIdGet(partAId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal / TrustContact / ExternalExaminer | Returns file
         * @param {number} partBId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsGetPartBFilePartBIdGet(partBId: number, options?: any): AxiosPromise<FileViewResponse> {
            return FileAtcsApiFp(configuration).apiV2FileAtcsGetPartBFilePartBIdGet(partBId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal, TrustCoordinator, TrustContact | Returns FileId
         * @param {ComplianceFormFileRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsSaveComplianceFormFilePost(body?: ComplianceFormFileRequest, options?: any): AxiosPromise<Int32Response> {
            return FileAtcsApiFp(configuration).apiV2FileAtcsSaveComplianceFormFilePost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary AllAtcs | Returns FileId
         * @param {FileRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsSaveEeSignUpFormFilePost(body?: FileRequest, options?: any): AxiosPromise<Int32Response> {
            return FileAtcsApiFp(configuration).apiV2FileAtcsSaveEeSignUpFormFilePost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary AllAtcs | Returns FileId
         * @param {FileRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsSaveFilePost(body?: FileRequest, options?: any): AxiosPromise<Int32Response> {
            return FileAtcsApiFp(configuration).apiV2FileAtcsSaveFilePost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TrustInvestigator | Returns file
         * @param {number} complianceFormId 
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsTrustInvestigatorGetComplianceFormAdditionalFileComplianceFormIdFileIdGet(complianceFormId: number, fileId: number, options?: any): AxiosPromise<FileViewResponse> {
            return FileAtcsApiFp(configuration).apiV2FileAtcsTrustInvestigatorGetComplianceFormAdditionalFileComplianceFormIdFileIdGet(complianceFormId, fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TrustInvestigator | Returns EE Report - Overview
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsTrustInvestigatorGetComplianceFormFileAttachmentsComplianceFormIdGet(complianceFormId: number, options?: any): AxiosPromise<ComplianceFormFileResponse> {
            return FileAtcsApiFp(configuration).apiV2FileAtcsTrustInvestigatorGetComplianceFormFileAttachmentsComplianceFormIdGet(complianceFormId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TrustInvestigator | Returns file
         * @param {number} fileId 
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsTrustInvestigatorGetComplianceFormFileByIdFileIdComplianceFormIdGet(fileId: number, complianceFormId: number, options?: any): AxiosPromise<FileViewResponse> {
            return FileAtcsApiFp(configuration).apiV2FileAtcsTrustInvestigatorGetComplianceFormFileByIdFileIdComplianceFormIdGet(fileId, complianceFormId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TrustInvestigator | Returns file
         * @param {number} eeReportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsTrustInvestigatorGetEeReportFileEeReportIdGet(eeReportId: number, options?: any): AxiosPromise<FileViewResponse> {
            return FileAtcsApiFp(configuration).apiV2FileAtcsTrustInvestigatorGetEeReportFileEeReportIdGet(eeReportId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TrustInvestigator | Returns file
         * @param {number} eeReportId 
         * @param {number} regeneratedFileLogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsTrustInvestigatorGetEeReportFileEeReportIdRegeneratedFileLogIdGet(eeReportId: number, regeneratedFileLogId: number, options?: any): AxiosPromise<FileViewResponse> {
            return FileAtcsApiFp(configuration).apiV2FileAtcsTrustInvestigatorGetEeReportFileEeReportIdRegeneratedFileLogIdGet(eeReportId, regeneratedFileLogId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TrustInvestigator | Returns EeReport Logs
         * @param {number} eeReportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsTrustInvestigatorGetEeReportFileLogsEeReportIdGet(eeReportId: number, options?: any): AxiosPromise<RegeneratedFileLogIEnumerableResponse> {
            return FileAtcsApiFp(configuration).apiV2FileAtcsTrustInvestigatorGetEeReportFileLogsEeReportIdGet(eeReportId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TrustInvestigator | Returns PartA Logs
         * @param {number} partAId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsTrustInvestigatorGetPartAFileLogsPartAIdGet(partAId: number, options?: any): AxiosPromise<RegeneratedFileLogIEnumerableResponse> {
            return FileAtcsApiFp(configuration).apiV2FileAtcsTrustInvestigatorGetPartAFileLogsPartAIdGet(partAId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TrustInvestigator | Returns file
         * @param {number} partAId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsTrustInvestigatorGetPartAFilePartAIdGet(partAId: number, options?: any): AxiosPromise<FileViewResponse> {
            return FileAtcsApiFp(configuration).apiV2FileAtcsTrustInvestigatorGetPartAFilePartAIdGet(partAId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TrustInvestigator | Returns file
         * @param {number} partAId 
         * @param {number} regeneratedFileLogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsTrustInvestigatorGetPartAFilePartAIdRegeneratedFileLogIdGet(partAId: number, regeneratedFileLogId: number, options?: any): AxiosPromise<FileViewResponse> {
            return FileAtcsApiFp(configuration).apiV2FileAtcsTrustInvestigatorGetPartAFilePartAIdRegeneratedFileLogIdGet(partAId, regeneratedFileLogId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TrustInvestigator | Returns PartB Logs
         * @param {number} partBId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsTrustInvestigatorGetPartBFileLogsPartBIdGet(partBId: number, options?: any): AxiosPromise<RegeneratedFileLogIEnumerableResponse> {
            return FileAtcsApiFp(configuration).apiV2FileAtcsTrustInvestigatorGetPartBFileLogsPartBIdGet(partBId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TrustInvestigator | Returns file
         * @param {number} partBId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsTrustInvestigatorGetPartBFilePartBIdGet(partBId: number, options?: any): AxiosPromise<FileViewResponse> {
            return FileAtcsApiFp(configuration).apiV2FileAtcsTrustInvestigatorGetPartBFilePartBIdGet(partBId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TrustInvestigator | Returns file
         * @param {number} partBId 
         * @param {number} regeneratedFileLogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2FileAtcsTrustInvestigatorGetPartBFilePartBIdRegeneratedFileLogIdGet(partBId: number, regeneratedFileLogId: number, options?: any): AxiosPromise<FileViewResponse> {
            return FileAtcsApiFp(configuration).apiV2FileAtcsTrustInvestigatorGetPartBFilePartBIdRegeneratedFileLogIdGet(partBId, regeneratedFileLogId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FileAtcsApi - object-oriented interface
 * @export
 * @class FileAtcsApi
 * @extends {BaseAPI}
 */
export class FileAtcsApi extends BaseAPI {
    /**
     * 
     * @summary TaAll | Delete AdditionalFile
     * @param {number} complianceFormId 
     * @param {number} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileAtcsApi
     */
    public apiV2FileAtcsAdminDeleteAdditionalFileComplianceFormIdFileIdDelete(complianceFormId: number, fileId: number, options?: any) {
        return FileAtcsApiFp(this.configuration).apiV2FileAtcsAdminDeleteAdditionalFileComplianceFormIdFileIdDelete(complianceFormId, fileId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TaAll | Delete File
     * @param {number} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileAtcsApi
     */
    public apiV2FileAtcsAdminDeleteFileFileIdDelete(fileId: number, options?: any) {
        return FileAtcsApiFp(this.configuration).apiV2FileAtcsAdminDeleteFileFileIdDelete(fileId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TaAll | Returns file as stream
     * @param {number} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileAtcsApi
     */
    public apiV2FileAtcsAdminDownloadStreamFileIdGet(fileId: number, options?: any) {
        return FileAtcsApiFp(this.configuration).apiV2FileAtcsAdminDownloadStreamFileIdGet(fileId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns file
     * @param {number} eeReportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileAtcsApi
     */
    public apiV2FileAtcsAdminGetEeReportFileEeReportIdGet(eeReportId: number, options?: any) {
        return FileAtcsApiFp(this.configuration).apiV2FileAtcsAdminGetEeReportFileEeReportIdGet(eeReportId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns file
     * @param {number} eeReportId 
     * @param {number} regeneratedFileLogId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileAtcsApi
     */
    public apiV2FileAtcsAdminGetEeReportFileEeReportIdRegeneratedFileLogIdGet(eeReportId: number, regeneratedFileLogId: number, options?: any) {
        return FileAtcsApiFp(this.configuration).apiV2FileAtcsAdminGetEeReportFileEeReportIdRegeneratedFileLogIdGet(eeReportId, regeneratedFileLogId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns EeReport Logs
     * @param {number} eeReportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileAtcsApi
     */
    public apiV2FileAtcsAdminGetEeReportFileLogsEeReportIdGet(eeReportId: number, options?: any) {
        return FileAtcsApiFp(this.configuration).apiV2FileAtcsAdminGetEeReportFileLogsEeReportIdGet(eeReportId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TaAll | Returns file
     * @param {number} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileAtcsApi
     */
    public apiV2FileAtcsAdminGetFileByIdFileIdGet(fileId: number, options?: any) {
        return FileAtcsApiFp(this.configuration).apiV2FileAtcsAdminGetFileByIdFileIdGet(fileId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns PartA Logs
     * @param {number} partAId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileAtcsApi
     */
    public apiV2FileAtcsAdminGetPartAFileLogsPartAIdGet(partAId: number, options?: any) {
        return FileAtcsApiFp(this.configuration).apiV2FileAtcsAdminGetPartAFileLogsPartAIdGet(partAId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns file
     * @param {number} partAId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileAtcsApi
     */
    public apiV2FileAtcsAdminGetPartAFilePartAIdGet(partAId: number, options?: any) {
        return FileAtcsApiFp(this.configuration).apiV2FileAtcsAdminGetPartAFilePartAIdGet(partAId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns file
     * @param {number} partAId 
     * @param {number} regeneratedFileLogId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileAtcsApi
     */
    public apiV2FileAtcsAdminGetPartAFilePartAIdRegeneratedFileLogIdGet(partAId: number, regeneratedFileLogId: number, options?: any) {
        return FileAtcsApiFp(this.configuration).apiV2FileAtcsAdminGetPartAFilePartAIdRegeneratedFileLogIdGet(partAId, regeneratedFileLogId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns PartB Logs
     * @param {number} partBId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileAtcsApi
     */
    public apiV2FileAtcsAdminGetPartBFileLogsPartBIdGet(partBId: number, options?: any) {
        return FileAtcsApiFp(this.configuration).apiV2FileAtcsAdminGetPartBFileLogsPartBIdGet(partBId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns file
     * @param {number} partBId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileAtcsApi
     */
    public apiV2FileAtcsAdminGetPartBFilePartBIdGet(partBId: number, options?: any) {
        return FileAtcsApiFp(this.configuration).apiV2FileAtcsAdminGetPartBFilePartBIdGet(partBId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns file
     * @param {number} partBId 
     * @param {number} regeneratedFileLogId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileAtcsApi
     */
    public apiV2FileAtcsAdminGetPartBFilePartBIdRegeneratedFileLogIdGet(partBId: number, regeneratedFileLogId: number, options?: any) {
        return FileAtcsApiFp(this.configuration).apiV2FileAtcsAdminGetPartBFilePartBIdRegeneratedFileLogIdGet(partBId, regeneratedFileLogId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Ta All | Returns true when File is saved
     * @param {ComplianceFormFileRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileAtcsApi
     */
    public apiV2FileAtcsAdminSaveComplianceFormAdditionalFilePost(body?: ComplianceFormFileRequest, options?: any) {
        return FileAtcsApiFp(this.configuration).apiV2FileAtcsAdminSaveComplianceFormAdditionalFilePost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TaAll | Returns FileId
     * @param {FileRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileAtcsApi
     */
    public apiV2FileAtcsAdminSaveExternalExaminerFilePost(body?: FileRequest, options?: any) {
        return FileAtcsApiFp(this.configuration).apiV2FileAtcsAdminSaveExternalExaminerFilePost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary AllAtcs | Delete File
     * @param {number} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileAtcsApi
     */
    public apiV2FileAtcsDeleteFileFileIdDelete(fileId: number, options?: any) {
        return FileAtcsApiFp(this.configuration).apiV2FileAtcsDeleteFileFileIdDelete(fileId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary AllAtcs | Returns file as stream
     * @param {number} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileAtcsApi
     */
    public apiV2FileAtcsDownloadStreamFileIdGet(fileId: number, options?: any) {
        return FileAtcsApiFp(this.configuration).apiV2FileAtcsDownloadStreamFileIdGet(fileId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary AllAtcs | Returns file
     * @param {number} fileId 
     * @param {number} complianceFormId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileAtcsApi
     */
    public apiV2FileAtcsGetComplianceFormFileByIdFileIdComplianceFormIdGet(fileId: number, complianceFormId: number, options?: any) {
        return FileAtcsApiFp(this.configuration).apiV2FileAtcsGetComplianceFormFileByIdFileIdComplianceFormIdGet(fileId, complianceFormId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary ExternalExaminer | Returns file
     * @param {number} eeReportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileAtcsApi
     */
    public apiV2FileAtcsGetEeReportFileEeReportIdGet(eeReportId: number, options?: any) {
        return FileAtcsApiFp(this.configuration).apiV2FileAtcsGetEeReportFileEeReportIdGet(eeReportId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary AllAtcs | Returns file
     * @param {number} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileAtcsApi
     */
    public apiV2FileAtcsGetFileByIdFileIdGet(fileId: number, options?: any) {
        return FileAtcsApiFp(this.configuration).apiV2FileAtcsGetFileByIdFileIdGet(fileId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal / TrustContact / ExternalExaminer | Returns file
     * @param {number} partAId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileAtcsApi
     */
    public apiV2FileAtcsGetPartAFilePartAIdGet(partAId: number, options?: any) {
        return FileAtcsApiFp(this.configuration).apiV2FileAtcsGetPartAFilePartAIdGet(partAId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal / TrustContact / ExternalExaminer | Returns file
     * @param {number} partBId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileAtcsApi
     */
    public apiV2FileAtcsGetPartBFilePartBIdGet(partBId: number, options?: any) {
        return FileAtcsApiFp(this.configuration).apiV2FileAtcsGetPartBFilePartBIdGet(partBId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal, TrustCoordinator, TrustContact | Returns FileId
     * @param {ComplianceFormFileRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileAtcsApi
     */
    public apiV2FileAtcsSaveComplianceFormFilePost(body?: ComplianceFormFileRequest, options?: any) {
        return FileAtcsApiFp(this.configuration).apiV2FileAtcsSaveComplianceFormFilePost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary AllAtcs | Returns FileId
     * @param {FileRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileAtcsApi
     */
    public apiV2FileAtcsSaveEeSignUpFormFilePost(body?: FileRequest, options?: any) {
        return FileAtcsApiFp(this.configuration).apiV2FileAtcsSaveEeSignUpFormFilePost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary AllAtcs | Returns FileId
     * @param {FileRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileAtcsApi
     */
    public apiV2FileAtcsSaveFilePost(body?: FileRequest, options?: any) {
        return FileAtcsApiFp(this.configuration).apiV2FileAtcsSaveFilePost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TrustInvestigator | Returns file
     * @param {number} complianceFormId 
     * @param {number} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileAtcsApi
     */
    public apiV2FileAtcsTrustInvestigatorGetComplianceFormAdditionalFileComplianceFormIdFileIdGet(complianceFormId: number, fileId: number, options?: any) {
        return FileAtcsApiFp(this.configuration).apiV2FileAtcsTrustInvestigatorGetComplianceFormAdditionalFileComplianceFormIdFileIdGet(complianceFormId, fileId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TrustInvestigator | Returns EE Report - Overview
     * @param {number} complianceFormId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileAtcsApi
     */
    public apiV2FileAtcsTrustInvestigatorGetComplianceFormFileAttachmentsComplianceFormIdGet(complianceFormId: number, options?: any) {
        return FileAtcsApiFp(this.configuration).apiV2FileAtcsTrustInvestigatorGetComplianceFormFileAttachmentsComplianceFormIdGet(complianceFormId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TrustInvestigator | Returns file
     * @param {number} fileId 
     * @param {number} complianceFormId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileAtcsApi
     */
    public apiV2FileAtcsTrustInvestigatorGetComplianceFormFileByIdFileIdComplianceFormIdGet(fileId: number, complianceFormId: number, options?: any) {
        return FileAtcsApiFp(this.configuration).apiV2FileAtcsTrustInvestigatorGetComplianceFormFileByIdFileIdComplianceFormIdGet(fileId, complianceFormId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TrustInvestigator | Returns file
     * @param {number} eeReportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileAtcsApi
     */
    public apiV2FileAtcsTrustInvestigatorGetEeReportFileEeReportIdGet(eeReportId: number, options?: any) {
        return FileAtcsApiFp(this.configuration).apiV2FileAtcsTrustInvestigatorGetEeReportFileEeReportIdGet(eeReportId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TrustInvestigator | Returns file
     * @param {number} eeReportId 
     * @param {number} regeneratedFileLogId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileAtcsApi
     */
    public apiV2FileAtcsTrustInvestigatorGetEeReportFileEeReportIdRegeneratedFileLogIdGet(eeReportId: number, regeneratedFileLogId: number, options?: any) {
        return FileAtcsApiFp(this.configuration).apiV2FileAtcsTrustInvestigatorGetEeReportFileEeReportIdRegeneratedFileLogIdGet(eeReportId, regeneratedFileLogId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TrustInvestigator | Returns EeReport Logs
     * @param {number} eeReportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileAtcsApi
     */
    public apiV2FileAtcsTrustInvestigatorGetEeReportFileLogsEeReportIdGet(eeReportId: number, options?: any) {
        return FileAtcsApiFp(this.configuration).apiV2FileAtcsTrustInvestigatorGetEeReportFileLogsEeReportIdGet(eeReportId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TrustInvestigator | Returns PartA Logs
     * @param {number} partAId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileAtcsApi
     */
    public apiV2FileAtcsTrustInvestigatorGetPartAFileLogsPartAIdGet(partAId: number, options?: any) {
        return FileAtcsApiFp(this.configuration).apiV2FileAtcsTrustInvestigatorGetPartAFileLogsPartAIdGet(partAId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TrustInvestigator | Returns file
     * @param {number} partAId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileAtcsApi
     */
    public apiV2FileAtcsTrustInvestigatorGetPartAFilePartAIdGet(partAId: number, options?: any) {
        return FileAtcsApiFp(this.configuration).apiV2FileAtcsTrustInvestigatorGetPartAFilePartAIdGet(partAId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TrustInvestigator | Returns file
     * @param {number} partAId 
     * @param {number} regeneratedFileLogId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileAtcsApi
     */
    public apiV2FileAtcsTrustInvestigatorGetPartAFilePartAIdRegeneratedFileLogIdGet(partAId: number, regeneratedFileLogId: number, options?: any) {
        return FileAtcsApiFp(this.configuration).apiV2FileAtcsTrustInvestigatorGetPartAFilePartAIdRegeneratedFileLogIdGet(partAId, regeneratedFileLogId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TrustInvestigator | Returns PartB Logs
     * @param {number} partBId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileAtcsApi
     */
    public apiV2FileAtcsTrustInvestigatorGetPartBFileLogsPartBIdGet(partBId: number, options?: any) {
        return FileAtcsApiFp(this.configuration).apiV2FileAtcsTrustInvestigatorGetPartBFileLogsPartBIdGet(partBId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TrustInvestigator | Returns file
     * @param {number} partBId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileAtcsApi
     */
    public apiV2FileAtcsTrustInvestigatorGetPartBFilePartBIdGet(partBId: number, options?: any) {
        return FileAtcsApiFp(this.configuration).apiV2FileAtcsTrustInvestigatorGetPartBFilePartBIdGet(partBId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TrustInvestigator | Returns file
     * @param {number} partBId 
     * @param {number} regeneratedFileLogId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileAtcsApi
     */
    public apiV2FileAtcsTrustInvestigatorGetPartBFilePartBIdRegeneratedFileLogIdGet(partBId: number, regeneratedFileLogId: number, options?: any) {
        return FileAtcsApiFp(this.configuration).apiV2FileAtcsTrustInvestigatorGetPartBFilePartBIdRegeneratedFileLogIdGet(partBId, regeneratedFileLogId, options).then((request) => request(this.axios, this.basePath));
    }
}
